module.exports = __webpack_public_path__ + "static/sberbank-carousel-1bda80379bce73644a7c5c9d47662759.jpg";